module.exports = __webpack_public_path__ + "img/title1.194712ea.png";